// 고객 A/S 접수 링크 액션(rpc) — FormData(id 접수 번호·category·body·file 0~6장)를 multipart 로 보낸다.
import { shareRpc } from "@/api/client";

export const submitAsRequestByLink = (token: string, form: FormData) => shareRpc("c", token, "submitAsRequestByLink", token, form);
